import { isEmpty } from 'lodash'

const locationTypeImageFormInitialValues = values => ({
  id: values.id,
  image: isEmpty(values.imageUrl)
    ? []
    : [{ uid: '0', status: 'done', url: values.imageUrl }],
  icon: isEmpty(values.iconUrl)
    ? []
    : [{ uid: '0', status: 'done', url: values.iconUrl }],
})

export default locationTypeImageFormInitialValues
